import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import React from "react";
import { Disclaimer } from "./Disclaimer";

export interface SummaryProps {
    result?: {
        netCreditAmount?: number;
        interestRate?: number;
        ratePerMonth?: number | null;
        effectiveAnnualInterestRate?: number;
        grossCreditAmount?: number;
        formSchema?: {
            ratePerMonthTitle?: string;
            disclaimer?: {
                textOne?: string;
                textTwo?: string;
                hyperlink?: string;
                hyperlinkText?: string;
            };
        };
    };
    loading?: boolean;
    hasError?: boolean;
}

export const Summary: React.FC<SummaryProps> = ({ result, loading, hasError }) => (
    <Mary.base.BaseConsumer>
        {({ getTheme }) => (
            <>
                <Mary.base.Div
                    className="scl-o-form__summary"
                >
                    {loading ?

                        <Mary.atoms.loadingindicator.LoadingIndicator
                            type={Mary.atoms.loadingindicator.LoadingIndications.DEFAULT}
                            theme={{ palette: Mary.theme.ThemePalette.CONTRAST_PRIMARY }}
                        /> : (
                            <>
                                <Mary.atoms.Heading level={
                                    getTheme() !== Mary.theme.Themes.MOBILIST ? Mary.atoms.Headings.H2
                                        : Mary.atoms.Headings.H3} headingStyle={Mary.atoms.Headings.H5}>
                                    {result?.formSchema?.ratePerMonthTitle ?? ""}
                                </Mary.atoms.Heading>
                                <div
                                    style={{
                                        marginTop: "5px",
                                        height: "30px",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <Mary.atoms.Heading
                                        level={Mary.atoms.Headings.H1}
                                        headingStyle={Mary.atoms.Headings.H3}>
                                        {hasError ? "-" :
                                            !!result?.ratePerMonth && result.ratePerMonth === 0 ? "€ 0"
                                                : (result?.ratePerMonth === null || result?.ratePerMonth === undefined)
                                                    ? "-" : `€ ${result?.ratePerMonth}`}
                                    </Mary.atoms.Heading>
                                    <span style={{ marginLeft: "5px", marginTop: "5px" }}>
                                        {hasError ? "" :
                                            !!result?.ratePerMonth && result.ratePerMonth === 0 ? ""
                                                : (result?.ratePerMonth === null || result?.ratePerMonth === undefined)
                                                    ? "" : "/mnd"}
                                    </span>
                                </div>
                            </>)}
                    <Disclaimer result={result}/>
                </Mary.base.Div>
            </>
        )}</Mary.base.BaseConsumer>);
